import { createSelector } from 'reselect';

const selectReconciliationItems = (state: any) => state.reconciliationItems;


export const selectReconciliationItemCurrentItem = createSelector([selectReconciliationItems], (reconciliationItems) => reconciliationItems.current);

export const selectReconciliationItemsListItems = createSelector([selectReconciliationItems], (reconciliationItems) => reconciliationItems.list);

export const selectReconciliationItemItemById = (itemId: any) =>
    createSelector(selectReconciliationItemsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectReconciliationItemQueryItems = createSelector([selectReconciliationItems], (reconciliationItems) => reconciliationItems.query);

export const selectReconciliationItemCreatedItem = createSelector([selectReconciliationItems], (reconciliationItems) => reconciliationItems.create);

export const selectReconciliationItemUpdatedItem = createSelector([selectReconciliationItems], (reconciliationItems) => reconciliationItems.update);

export const selectReconciliationItemReadItem = createSelector([selectReconciliationItems], (reconciliationItems) => reconciliationItems.read);

export const selectReconciliationItemDeletedItem = createSelector([selectReconciliationItems], (reconciliationItems) => reconciliationItems.delete);

export const selectReconciliationItemSearchedItems = createSelector([selectReconciliationItems], (reconciliationItems) => reconciliationItems.search);

export const selectReconciliationItemItemsCount = createSelector([selectReconciliationItems], (reconciliationItems) => reconciliationItems.count);

export const selectReconciliationItemItemsFilter = createSelector([selectReconciliationItems], (reconciliationItems) => reconciliationItems.filter);